import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { MESSAGES as messages, FALLBACK_LOCALE as fallbackLocale } from '@/locales';

import { getLocale } from '@/locales/helpers';

Vue.use(VueI18n);

export default new VueI18n({
  messages,
  fallbackLocale,
  locale: getLocale(),
});
